import React from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../../context/SettingsContext';

export default function Footer() {
  const { settings, hours, todayLabel } = useSettings();
  const phoneDigits = (settings.store_phone || '').replace(/\D/g, '');
  const techPhoneDigits = (settings.screen_savers_phone || '').replace(/\D/g, '');

  return (
    <footer style={{ background: '#111b33', color: 'rgba(255,255,255,0.75)', marginTop: 'auto' }}>
      {/* Main footer */}
      <div className="container" style={{ padding: '52px 20px 40px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 40 }}>

        {/* Brand */}
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
            <div style={{ width: 38, height: 38, background: '#c9a227', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: 18, color: '#1a2744' }}>PP</div>
            <div>
              <div style={{ color: '#fff', fontWeight: 800, fontSize: 15, lineHeight: 1.2 }}>Premier Pawn</div>
              <div style={{ color: '#c9a227', fontWeight: 600, fontSize: 11 }}>& Tech Repair</div>
            </div>
          </div>
          <p style={{ fontSize: 13, lineHeight: 1.7, marginBottom: 16 }}>
            Natchitoches' trusted pawn shop for {settings.years_in_business || '15'} years. Buy, sell, and pawn with confidence.
          </p>
          <div style={{ display: 'flex', gap: 10 }}>
            {[['f', settings.facebook_url, '#3b5998'],
              ['📷', settings.instagram_url, '#e1306c']].filter(([, url]) => url).map(([icon, url, color]) => (
              <a key={url} href={url} target="_blank" rel="noreferrer"
                style={{ width: 34, height: 34, borderRadius: 6, background: 'rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 13, transition: 'background 0.15s' }}
                onMouseEnter={e => e.currentTarget.style.background = color}
                onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.08)'}>
                {icon}
              </a>
            ))}
          </div>
        </div>

        {/* Quick links */}
        <div>
          <h4 style={{ color: '#fff', fontWeight: 700, fontSize: 14, marginBottom: 16, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Quick Links</h4>
          {[['Shop All Inventory', '/shop'], ['Guns & Sporting Goods', '/shop/guns-sporting'], ['Electronics', '/shop/electronics'],
            ['Jewelry & Watches', '/shop/jewelry'], ['Sell or Pawn to Us', '/sell'], ['Tech Repair', '/tech-repair'],
            ['About Us', '/about'], ['Contact', '/contact']].map(([label, href]) => (
            <Link key={href} to={href} style={{ display: 'block', fontSize: 13, color: 'rgba(255,255,255,0.65)', marginBottom: 8, transition: 'color 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.color = '#c9a227'}
              onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.65)'}>
              {label}
            </Link>
          ))}
        </div>

        {/* Hours */}
        <div>
          <h4 style={{ color: '#fff', fontWeight: 700, fontSize: 14, marginBottom: 16, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Hours</h4>
          {hours.map(([day, dayHours]) => (
            <div key={day} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 6, color: day === todayLabel ? '#c9a227' : 'rgba(255,255,255,0.65)', fontWeight: day === todayLabel ? 700 : 400 }}>
              <span>{day}</span><span>{dayHours}</span>
            </div>
          ))}
        </div>

        {/* Contact */}
        <div>
          <h4 style={{ color: '#fff', fontWeight: 700, fontSize: 14, marginBottom: 16, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Contact</h4>
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.65)', lineHeight: 1.8 }}>
            <div>📍 {settings.store_address}</div>
            <div style={{ paddingLeft: 20 }}>{settings.store_city}, {settings.store_state} {settings.store_zip}</div>
            <div style={{ marginTop: 8 }}>📞 <a href={`tel:${phoneDigits}`} style={{ color: 'rgba(255,255,255,0.75)' }}>{settings.store_phone}</a></div>
            <div style={{ marginTop: 4 }}>✉️ <a href={`mailto:${settings.store_email}`} style={{ color: 'rgba(255,255,255,0.75)' }}>{settings.store_email}</a></div>
            <div style={{ marginTop: 12, padding: '10px 12px', background: 'rgba(201,162,39,0.12)', borderRadius: 8, borderLeft: '3px solid #c9a227' }}>
              <div style={{ color: '#c9a227', fontWeight: 700, fontSize: 12, marginBottom: 2 }}>Tech Repair (Screen Savers)</div>
              <a href={`tel:${techPhoneDigits}`} style={{ color: 'rgba(255,255,255,0.75)' }}>{settings.screen_savers_phone}</a>
              <div><a href={`mailto:${settings.tech_repair_email}`} style={{ color: 'rgba(255,255,255,0.75)' }}>{settings.tech_repair_email}</a></div>
            </div>
          </div>
        </div>
      </div>

      {/* FFL notice */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', padding: '16px 0' }}>
        <div className="container" style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', textAlign: 'center', lineHeight: 1.6 }}>
          Premier Pawn & Tech Repair is a licensed Federal Firearms Dealer (FFL). All firearm transfers comply with federal and Louisiana state law.
          Online firearm purchases require transfer through a local FFL dealer. Buyer must complete ATF Form 4473 and pass NICS background check.
        </div>
      </div>

      {/* Bottom bar */}
      <div style={{ background: '#0d1526', padding: '14px 0' }}>
        <div className="container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, fontSize: 12, color: 'rgba(255,255,255,0.35)' }}>
          <span>© {new Date().getFullYear()} Premier Pawn & Tech Repair. All rights reserved.</span>
          <div style={{ display: 'flex', gap: 20 }}>
            <Link to="/privacy" style={{ color: 'rgba(255,255,255,0.35)' }}>Privacy Policy</Link>
            <Link to="/terms" style={{ color: 'rgba(255,255,255,0.35)' }}>Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
